/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type TicketEntityTypeEnum = "containers" | "shipments" | "%future added value";
export type TicketTypeEnum = "add_documents_and_photos" | "misc" | "request_for_documents" | "request_for_shipment_release" | "request_to_add_contact_link" | "request_to_create_a_new_contact" | "request_to_create_a_new_container" | "request_to_create_a_new_poa" | "request_to_create_a_new_shipment" | "request_to_create_container_shipment" | "signed_document_details" | "%future added value";
export type infoRaiseTicketInput = {
    clientMutationId?: string | null;
    entityType: TicketEntityTypeEnum;
    entitySlug: string;
    title?: string | null;
    description?: string | null;
    ticketType: TicketTypeEnum;
    contactSlug: string;
};
export type LiveRequestAddDialogMutationVariables = {
    input: infoRaiseTicketInput;
};
export type LiveRequestAddDialogMutationResponse = {
    readonly infoRaiseTicket: {
        readonly clientMutationId: string | null;
    } | null;
};
export type LiveRequestAddDialogMutation = {
    readonly response: LiveRequestAddDialogMutationResponse;
    readonly variables: LiveRequestAddDialogMutationVariables;
};



/*
mutation LiveRequestAddDialogMutation(
  $input: infoRaiseTicketInput!
) {
  infoRaiseTicket(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoRaiseTicketPayload",
    "kind": "LinkedField",
    "name": "infoRaiseTicket",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LiveRequestAddDialogMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LiveRequestAddDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e6249d0dd7138c2687f370e5736b9aae",
    "id": null,
    "metadata": {},
    "name": "LiveRequestAddDialogMutation",
    "operationKind": "mutation",
    "text": "mutation LiveRequestAddDialogMutation(\n  $input: infoRaiseTicketInput!\n) {\n  infoRaiseTicket(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'a49965ad0834eaf137e687d8f7c74f54';
export default node;
